import useFirebase from "../../../../../useFirebase";
import { useSelector } from "react-redux";

function useVideoSettings(device, videoSettingData, setVideoSettingData) {
  const { getCollectionData, postCollectionData, createCollectionData } = useFirebase();
  const { setRulesData } = useSelector(({ setRules }) => setRules);

  function callFireStore(payload) {
    // console.log(payload);

    const submittingValues = {
      videoKeywords: payload.videoKeywords,
      videoMonitoringEnabled: payload?.videoMonitoringEnabled,
    };

    const newPayload = {
      setRulesActiveInActiveStatus: { ...setRulesData?.setRulesActiveInActiveStatus, videoMonitoringEnabled: submittingValues?.videoMonitoringEnabled },
      videomonitoring: submittingValues
    }

    if(setRulesData) {
      postCollectionData(device, newPayload)
    } else {
      createCollectionData(device, newPayload)
    }

    getCollectionData(device);
  }

  function handleToggleChange(e) {
    const { name, checked } = e.target;
    const collectionPayload = {
      ...videoSettingData,
      videoKeywords: videoSettingData?.videoKeywords,
      videoMonitoringEnabled: videoSettingData?.videoMonitoringEnabled,
    };

    if (name === "VIDEO_MONITORING_ENABLED") {
      collectionPayload["videoMonitoringEnabled"] = checked ? true : false;
    }
    callFireStore(collectionPayload);
  }

  function handleClear(e) {
    const collectionPayload = {
      videoKeywords: [],
      videoMonitoringEnabled: videoSettingData?.videoMonitoringEnabled,
    };

    callFireStore(collectionPayload);
  }

  function handleClearOneKeyword(deleteItem) {
    const collectionPayload = {
      videoKeywords: videoSettingData?.videoKeywords?.filter(
        (item) => item != deleteItem
      ),
      videoMonitoringEnabled: videoSettingData?.videoMonitoringEnabled,
    };

    callFireStore(collectionPayload);
  }

  function handleApply(e) {
    if (!videoSettingData?.keywordData) return;
    const collectionPayload = {
      videoKeywords: [
        ...videoSettingData?.videoKeywords,
        ...videoSettingData?.keywordData.split(","),
      ],
      videoMonitoringEnabled: videoSettingData?.videoMonitoringEnabled,
    };

    callFireStore(collectionPayload);
  }

  function handleInputChange(e) {
    const collectionPayload = {
      ...videoSettingData,
      keywordData: e?.target?.value,
    };
    setVideoSettingData(collectionPayload);
  }
  return {
    handleToggleChange,
    handleClear,
    handleApply,
    handleInputChange,
    handleClearOneKeyword,
  };
}

export default useVideoSettings;
